module.exports = __webpack_public_path__ + "2020celebration/img/family-r-2.2150a78e.png";